import React, {useEffect, useState} from 'react';
import BasketInfo from "../basket/BasketInfo";
import IconTitleValue from "components/textValue/IconTitleValue";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import Space from "../../../components/space/Space";
import TitleAddHeader from "../address/TitleAddHeader";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import messages from "res/messages/farsi";
import {addressViewModel} from "../../../viewModels/Address.viewModel";
import {Divider} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {getTextViewHeight, IsLP_MP} from "my-styles/media/media";
import IconTitleButton from "components/buttons/IconTitleButton";
import IconTextView from "components/input/IconTextView";
import AutocompleteComboBox from "components/input/AutocompleteComboBox";
import StandardButton from "components/buttons/StandardButton";
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import DialogMessage from "components/dialogMessage/DialogMessage";
import CustomCheckBox from "components/checkBox/CustomCheckBox";
import CircleIconButton from "components/buttons/CircleIconButton";

import ICInfo from "res/images/info.png";
import ICCash from "res/images/cash.png";
import ICPos from "res/images/pos.png";
import ICOnline from "res/images/online.png";
import ICBackIcon from "res/images/back.png";
import ICEdit from 'res/images/edit_white.png';
import ICUserAccount from 'res/images/user.png';
import ICAddress from 'res/images/address.png';
import ICTitle from "res/images/title.png";
import ICDate from "res/images/calendar.png";
import ICTime from "res/images/timer.png";
import ICPaste from "res/images/paste.png";
import ICAddIcon from "res/images/add.png";

export const PAYMENTS_TYPES = {
    ONLINE: "1",
    POS: "2",
    CASH: "3"
}

export default function OrderRegister(props) {

    const history = useHistory()

    const [isCancelled, setIsCancelled] = useState(false)
    const [cart, setCart] = useState()
    const [showDialog, setShowDialog] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [addOrderResponseCode, setAddOrderResponseCode] = useState(0)
    const [deliverTypes, setDeliverTypes] = useState([])
    const [deliverDates, setDeliverDates] = useState([])
    const [deliverTimes, setDeliverTimes] = useState([])
    const [enableRewards, setEnableRewards] = useState([])
    const [transportationDescription, setTransportationDescription] = useState("")
    const [payment, setPayment] = useState()
    const [defaultAddress, setDefaultAddress] = useState()
    const [discountCode, setDiscountCode] = useState("")
    const [discountCodeMessage, setDiscountCodeMessage] = useState(undefined)
    const [discountCodeLoadingStatus, setDiscountCodeLoadingStatus] = useState(false)
    const [environmentCheckedStatus, setEnvironmentCheckedStatus] = useState(false)
    const [useWalletCheckedStatus, setUseWalletCheckedStatus] = useState(false)
    const [selectedPayment, setSelectedPayment] = useState()
    const [selectedDeliverDate, setSelectedDeliverDate] = useState()
    const [selectedDeliverTime, setSelectedDeliverTime] = useState()
    const [dialogMessageShowStatus, setDialogMessageShowStatus] = useState(false)
    const [wallet, setWallet] = useState(undefined)

    function requestCartChangeset(discountCode, useWallet, fromDiscount = true) {
        basketViewModel.getCartChangeset(
            discountCode, useWallet ? "1" : "0",
            (data) => {
                if (data.description === 350) {
                    if (fromDiscount && data.reward_list && data.reward_list.length > 0) {
                        if (data.reward_list[0].reward_id > 0 && data.reward_list[0].error_code === 0) {
                            setDiscountCodeMessage(data.reward_list[0].message)
                        } else {
                            props.onAlert(data.reward_list[0].message)
                        }
                    }

                    setCart(data)
                }
            }, () => {
                if (fromDiscount) {
                    props.onAlert(messages.discountCodeError)
                } else {
                    props.onAlert(messages.responseCodeIsNot200)
                }
            }, () => {
                if (fromDiscount) {
                    setDiscountCodeLoadingStatus(true)
                } else {
                    props.onLoading(true)
                }
            }, () => {
                if (fromDiscount) {
                    setDiscountCodeLoadingStatus(false)
                } else {
                    props.onLoading(false)
                }
            })
    }

    function requestGetAddresses() {
        addressViewModel.getAddresses((data) => {
            if (data.list && data.list.length > 0) {
                for (let address of data.list) {
                    if (address.is_default) {
                        setDefaultAddress(address)
                        break
                    }
                }
            }
            setTransportationDescription(data.transportation_description)
            if (localStorage.getItem('onlineRefrenceId') !== undefined &&
                localStorage.getItem('onlineRefrenceId') !== null &&
                localStorage.getItem('onlineRefrenceId') !== "null" &&
                localStorage.getItem('onlineRefrenceId') !== "") {
                requestPaymentTransaction()
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestPaymentTransaction() {
        let params = new FormData()
        params.append("refrence_id", localStorage.getItem('onlineRefrenceId'))
        callApi(Urls.getPaymentRequestTransaction, params, (data) => {
            if (data) {
                if (data.description === 200 || data.description === 202 || data.description === 203) {
                    setAddOrderResponseCode(data.description)
                    setDialogMessage(data.message)
                    setDialogTitle(messages.attention)
                    setShowDialog(true)
                }
            }
        }, () => {

        }, () => {

        }, () => {
            localStorage.setItem("onlineRefrenceId", "")
        })
    }

    function requestAddOrder(mapInventory) {
        let params = new FormData()
        params.append("address_id", defaultAddress ? defaultAddress.address_id : -1)
        params.append("payment_type", selectedPayment)
        params.append("shipping_date_type", "2")
        params.append("transportation_cost", cart.transportation_cost)
        params.append("reward_codes", discountCode)
        params.append("shipping_date", selectedDeliverDate.date + "," +
            selectedDeliverTime.start_time + ":" + selectedDeliverTime.end_time)
        params.append("map_inventory", mapInventory ? mapInventory : "0")
        params.append("environment_supporter", environmentCheckedStatus ? "1" : "0")
        params.append("use_wallet", useWalletCheckedStatus ? "1" : "0")
        params.append("total_used_wallet", wallet !== undefined ? wallet.current_value : 0)
        callApi(Urls.addOrder, params, (data) => {
            if (data.description === 611) {
                localStorage.removeItem("customerBehaviourGuid");
                basketViewModel.clearLocalCart()
                setAddOrderResponseCode(611)
                setDialogMessage(messages.successAddOrder + "\n" + messages.orderId + data.order_id)
                setDialogTitle(messages.success)
                setShowDialog(true)
            } else if (data.description === 625) {
                localStorage.setItem("onlineRefrenceId", data.order_id)
                props.onNavigate(history, "/beforePayment?token=" + data.order_id)
            }
        }, (data) => {
            if (data.description === 610) {
                window.open(data.link)
            } else if (data.description === 612 || data.description === 613) {
                setAddOrderResponseCode(data.description)
                if (data.description === 612) {
                    setDialogMessage(messages.basketChangeMessage)
                    setDialogTitle(messages.basketChange)
                } else if (data.description === 613) {
                    setDialogMessage(data.message)
                    setDialogTitle(messages.error)
                }
                setShowDialog(true)
            } else if (data.description === 635) {
                props.onAlert(data.message)
            }
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestCartSetting() {
        basketViewModel.getCartSetting(
            (data) => {
                if (data) {
                    requestGetAddresses()
                    setCart(data.cart)
                    setEnableRewards(data.enable_rewards)
                    setPayment(data.payment)
                    if (data.payment.online) {
                        setSelectedPayment(PAYMENTS_TYPES.ONLINE)
                    }
                    setDeliverTypes(data.shipping_date_types)
                    setDeliverDates(data.delivery_dates)

                    setWallet(data.wallet)
                }
            }, () => {
                if (isCancelled) return

                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            })
    }

    function requestDeliveryTimes(selectDate) {
        if (selectDate && selectDate.miladiDateKey) {
            basketViewModel.getDeliveryTimes(selectDate.miladiDateKey, (data) => {
                if (data) {
                    setDeliverTimes(data.delivery_times)
                } else {
                    setDeliverTimes([])
                }
            }, () => {
                if (isCancelled) return

                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            })
        }

    }

    function emptyAddressBox() {
        return <table className="center card fullWidth" style={{height: "10em"}}>
            <tbody>
            <tr>
                <td>
                    <div className="largeText marginSmall">
                        {messages.addressNotFound}
                    </div>
                    <StandardButton
                        icon={<img className={'xxSmallIcon'} src={ICAddIcon} alt={"Ø¢Ø¯Ø±Ø³ ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                        onClick={() => {
                            props.onNavigate(history, "/addressDetail", {fromBasket: true})
                        }}/>
                </td>
            </tr>
            </tbody>
        </table>
    }

    function deliverAddress() {
        return <div className="card">
            <Space/>
            <div className="largeTextBold marginSmall">
                {messages.selectDeliverAddress}
            </div>
            <Divider/>
            <IconTitleValue
                icon={<img src={ICTitle} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª" className="xxSmallIcon"/>}
                title={messages.titleAddress}
                value={defaultAddress.addrees_name}
                secondValue={transportationDescription ? transportationDescription : undefined}/>
            <IconTitleValue
                icon={<img src={ICUserAccount} alt="Ù¾ÙÙ Ú©Ø§Ø±Ø¨Ø±Û ØµØ±ÙÙ ÙØ§Ø±Ú©Øª" className="xxSmallIcon"/>}
                title={messages.deliverTakeName}
                value={defaultAddress.full_name}/>
            <table>
                <tbody>
                <tr>
                    <td className="fullWidth">
                        <IconTitleValue
                            icon={<img src={ICAddress} alt="Ø¢Ø¯Ø±Ø³ - ØµØ±ÙÙ ÙØ§Ø±Ú©Øª" className="xxSmallIcon"/>}
                            title={messages.fullAddress}
                            value={defaultAddress.address}/>
                    </td>
                    <td>
                        <div className="marginLeftRightSmall">
                            <IconTitleButtonRound
                                backgroundcolor={"var(--red_3)"}
                                height={"2.7em"}
                                width={"100%"}
                                direction="ltr"
                                fontSize="mediumTextBold"
                                onClick={() => {
                                    props.onNavigate(history, "/addressList", {fromBasket: true})
                                }}
                                icon={<img className="xxSmallIcon" src={ICEdit} alt="ÙÛØ³Øª Ø¢Ø¯Ø±Ø³ -ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"/>}
                                title={messages.changeAddress}/>
                        </div>
                    </td>
                </tr>
                {/*<tr><td><Space/></td></tr>*/}
                </tbody>
            </table>
        </div>
    }

    function deliverType() {
        return <div className="card marginTopSmall">
            <Space/>
            <div className="largeTextBold marginSmall">
                {messages.selectDeliverType}
            </div>
            <Divider/>
            <Space/>
            {(deliverDates && deliverDates.length > 0) &&
            <div className={IsLP_MP() ? "horizontalFullScreen" : "fullWidthWithOffsset"}>
                <div className="marginLeftRightSmall full">
                    <AutocompleteComboBox
                        getOptionLabel={(option) => option.farsiDate}
                        icon={<img className="xSmallIcon marginTopSmall marginRightSmall" src={ICDate} alt="ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"/>}
                        onChange={(event, value) => {
                            setSelectedDeliverDate(value)
                            requestDeliveryTimes(value)
                            if (value) {
                                //     for (const time of value.times_list) {
                                //         time.description = messages.fromTime + " " +
                                //             time.start_time + " " +
                                //             messages.to + " " + time.end_time
                                //     }
                                //     setDeliverTimes(value.times_list)
                                // } else {
                                //     setDeliverTimes([])
                            }
                        }}
                        options={deliverDates}
                        placeholder={messages.day}/>
                </div>
                <div className="marginLeftRightSmall full">
                    <AutocompleteComboBox
                        getOptionLabel={(option) => option.textDeliveryTime}
                        disabled={(option) => option.status}
                        icon={<img className="xSmallIcon marginTopSmall marginRightSmall" src={ICTime} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                        onChange={(event, value) => {
                            setSelectedDeliverTime(value)
                        }}
                        options={deliverTimes}
                        placeholder={messages.time}/>
                </div>
            </div>
            }
            <Space/>
        </div>
    }

    function onPaymentClick(type) {
        if (selectedPayment) {
            if (selectedPayment === type) {
                setSelectedPayment(undefined)
            } else {
                setSelectedPayment(type)
            }
        } else {
            setSelectedPayment(type)
        }
    }

    function paymentType() {
        return <div className={"card marginTopSmall"}>
            <Space/>
            <div className="largeTextBold marginSmall">
                {messages.selectPaymentType}
            </div>
            <Divider/>
            <table className="fullWidth center">
                <tbody>
                <tr>
                    {payment.online &&
                    <td>
                        <div className={(selectedPayment && selectedPayment === PAYMENTS_TYPES.ONLINE) ?
                            "marginSmall border_green" : "marginSmall border_white"}
                             onClick={() => {
                                 onPaymentClick(PAYMENTS_TYPES.ONLINE)
                             }}>
                            <IconTitleButton
                                fontSize="mediumTextBold"
                                isvertical={"true"}
                                icon={<img className="mediumIcon" src={ICOnline} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                title={messages.onlinePayment}/>
                        </div>
                    </td>
                    }
                    {payment.cash &&
                    <td>
                        <div className={(selectedPayment && selectedPayment === PAYMENTS_TYPES.CASH) ?
                            "marginSmall border_green" : "marginSmall border_white"}
                             onClick={() => {
                                 onPaymentClick(PAYMENTS_TYPES.CASH)
                             }}>
                            <IconTitleButton
                                fontSize="mediumTextBold"
                                isvertical={"true"}
                                icon={<img className="mediumIcon" src={ICCash} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                title={messages.cashPayment}/>
                        </div>
                    </td>
                    }
                    {payment.pos &&
                    <td>
                        <div className={(selectedPayment && selectedPayment === PAYMENTS_TYPES.POS) ?
                            "marginSmall border_green" : "marginSmall border_white"}
                             onClick={() => {
                                 onPaymentClick(PAYMENTS_TYPES.POS)
                             }}>
                            <IconTitleButton
                                fontSize="mediumTextBold"
                                isvertical={"true"}
                                icon={<img className="mediumIcon" src={ICPos} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                title={messages.posPayment}/>
                        </div>
                    </td>
                    }
                </tr>
                </tbody>
            </table>
        </div>
    }

    function reward() {
        return <div className="card">
            <Space height={"1em"}/>
            <div className="marginLeftRightMedium">
                {discountCodeMessage ?
                    <table className="fullWidth">
                        <tbody>
                        <tr>
                            <td className={"greenColor mediumTextBold"} style={{height: "3em"}}>
                                {discountCodeMessage}
                            </td>
                            <td>
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--blue_3)"}
                                    height={"2.7em"}
                                    width={"100%"}
                                    direction="ltr"
                                    fontSize="smallTextBold"
                                    onClick={() => {
                                        setDiscountCode(undefined)
                                        setDiscountCodeMessage(undefined)

                                        requestCartChangeset(undefined, useWalletCheckedStatus)
                                    }}
                                    title={messages.editReward}/>
                            </td>
                        </tr>
                        </tbody>
                    </table> :
                    <IconTextView
                        height={getTextViewHeight()}
                        enableRightButton={true}
                        enableLeftButton={(discountCode && discountCode.trim().length > 0)}
                        leftButtonLoadingStatus={discountCodeLoadingStatus}
                        leftButtonTitle={messages.use}
                        leftButtontextcolor={"blueColor"}
                        value={discountCode}
                        placeholder={messages.enterDiscountCode}
                        icon={<img className="xxSmallIcon" src={ICPaste} alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                        leftButtonOnClick={() => {
                            setDiscountCodeMessage(undefined)
                            if (discountCode && discountCode.length > 0) {
                                requestCartChangeset(discountCode, useWalletCheckedStatus)
                            } else {
                                props.onAlert(messages.enterDiscountCode)
                            }
                        }}
                        onEnterClick={() => {
                            setDiscountCodeMessage(undefined)
                            if (discountCode && discountCode.length > 0) {
                                requestCartChangeset(discountCode, useWalletCheckedStatus)
                            } else {
                                props.onAlert(messages.enterDiscountCode)
                            }
                        }}
                        rightButtonOnClick={() => {
                            if (navigator.clipboard !== undefined) {
                                navigator.clipboard.readText()
                                    .then(text => {
                                        if (text.trim() !== "") {
                                            setDiscountCode(text)
                                        }
                                    })
                            }
                        }}
                        onChange={(e) => {
                            setDiscountCode(e.target.value)
                        }}/>
                }
                <Space height={"1em"}/>
            </div>
        </div>
    }

    function environmentSupporter() {
        return <div className="marginTopMedium card mediumTextBold">
            <table>
                <tbody>
                <tr>
                    <td>
                        <CustomCheckBox
                            checked={environmentCheckedStatus}
                            onClick={() => {
                                setEnvironmentCheckedStatus(!environmentCheckedStatus)
                            }}/>
                    </td>
                    <td>
                        {messages.iAmEnvironmentSupporter}
                    </td>
                    <td>
                        <div className="marginRightMedium">
                            <CircleIconButton
                                hover={"var(--blue_3)"}
                                background={"var(--blue_3)"}
                                width={"1.1em"} height={"1.1em"}
                                icon={<img src={ICInfo} className="xSmallIcon" alt={"ØµØ±ÙÙ ÙØ§Ø±Ú©Øª"}/>}
                                onClick={() => {
                                    setDialogMessageShowStatus(true)
                                }}/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }

    function walletBox() {
        return <div className="marginTopMedium card mediumTextBold">
            <table>
                <tbody>
                <tr>
                    <td>
                        <CustomCheckBox
                            checked={useWalletCheckedStatus}
                            onClick={() => {
                                setUseWalletCheckedStatus(!useWalletCheckedStatus)
                                requestCartChangeset(discountCode, !useWalletCheckedStatus, false)
                            }}/>
                    </td>
                    <td style={{width: '100%', paddingLeft: '1rem'}}>
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <div>
                                {messages.useWallet}
                            </div>
                            <div style={{display: "flex", gap: '1rem'}}
                                 className="mediumText singleLine">
                                <div className="mediumText singleLine">
                                    <label>
                                        {messages.inventory}
                                    </label>
                                </div>
                                <div className="mediumTextBold singleLine">
                                    <label>
                                        {parseFloat(wallet.current_value).toLocaleString() + " " + messages.priceUnit}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }


    useEffect(() => {
        requestCartSetting()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div className="fullWidth">
        <div className="marginTopBottomSmall">
            {cart &&
            <TitleAddHeader
                icon={ICBackIcon}
                title={messages.basket}
                onIconClick={() => {
                    props.onNavigate(history, '/basket')
                }}/>
            }
        </div>
        <div className="hInLPT_vInFMS wInLPT100_wInFMS95">
            {cart &&
            <div className="wInLP60_wInT50_wInFMS100 marginSmall">
                {defaultAddress ?
                    deliverAddress() : emptyAddressBox()
                }
                <div>
                    {(deliverTypes && deliverTypes.length > 0) &&
                    deliverType()
                    }
                    {payment &&
                    paymentType()
                    }
                </div>
            </div>
            }
            <div className="wInLP40_wInT50_wInFMS100 marginSmall">
                {(enableRewards && cart) &&
                reward()
                }
                {wallet && wallet.show &&
                walletBox()
                }
                {cart &&
                environmentSupporter()
                }
                {cart &&
                <div className="marginTopBottomSmall">
                    <BasketInfo
                        {...props}
                        fromOrderRegister={true}
                        cart={cart}
                        onRegisterClick={() => {
                            if (!defaultAddress) {
                                props.onAlert(messages.selectDefaultAddressPlease)
                                return
                            }
                            if (!selectedDeliverDate || !selectedDeliverTime) {
                                props.onAlert(messages.selectDeliverDatePlease)
                                return
                            }
                            if (!selectedPayment) {
                                props.onAlert(messages.selectDefaultPaymentTypePlease)
                                return
                            }
                            requestAddOrder()
                        }}/>
                </div>
                }
            </div>
        </div>
        <DialogMessage
            showStatus={dialogMessageShowStatus}
            title={messages.environmentSupporter}
            message={messages.descriptionEnvironmentSupporter}
            submitTitle={messages.submit}
            onSubmitClicked={() => {
                setDialogMessageShowStatus(false)
            }}
        />
        <DialogMessage
            showStatus={showDialog}
            title={dialogTitle}
            message={dialogMessage}
            submitTitle={messages.ok}
            onSubmitClicked={() => {
                setShowDialog(false)
                setDialogMessage("")
                setDialogTitle("")
                if (addOrderResponseCode === 611) {
                    props.onNavigate(history, "/")
                } else if (addOrderResponseCode === 612 || addOrderResponseCode === 613) {
                    props.onNavigate(history, "/basket")
                } else if (addOrderResponseCode === 200) {
                    props.onNavigate(history, "/")
                } else if (addOrderResponseCode === 202) {
                    props.onNavigate(history, "/orders?s=-1&p=1")
                } else if (addOrderResponseCode === 203) {
                    props.onNavigate(history, "/orders?s=-1&p=1")
                }
            }}
        />
    </div>)

}